<template>
  <div>
    <div class="basePage" v-if="!$store.state.applyShow && !$store.state.applyShow2 && !$store.state.applyShow3 && !$store.state.paihangShow">
      <HomePage v-if="!isMobile()"></HomePage>
      <HomePageMobile v-else></HomePageMobile>
      <Copyright></Copyright>
    </div>
    <ApplyPage v-show="$store.state.applyShow"></ApplyPage>
    <!-- <ApplyPC v-show="$store.state.applyShow"></ApplyPC> -->
    <ApplyPC2 v-show="$store.state.applyShow2"></ApplyPC2>
    <ApplyPC3 v-show="$store.state.applyShow3"></ApplyPC3>
    <Paihang1 v-show="$store.state.paihangShow"></Paihang1>
  </div>
</template>

<script>
import HomePage from './components/HomePage.vue'
import HomePageMobile from './components/HomePageMobile.vue'
import ApplyPage from './components/ApplyPage.vue'
import ApplyPC2 from './components/ApplyPC2.vue'
import Paihang1 from './components/paihang1.vue'
// import ApplyPC from './components/ApplyPC.vue'
import Copyright from './components/copyright.vue'
import ApplyPC3 from './components/ApplyPC3.vue'

export default {
  components: {
    HomePage,
    HomePageMobile,
    ApplyPage,
    ApplyPC2,
    Paihang1,
    Copyright,
    ApplyPC3
    // ApplyPC
  },
  data () {
    return {
      showApplyPage: false,
      showBase: true
    }
  },
  methods: {
    isMobile () {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera

      // 常见的移动设备用户代理字符串特征
      // 注意：这个列表可能不完整，因为新的设备和浏览器会不断出现
      const mobileRegex =
        /android|iphone|ipad|ipod|blackberry|windows phone|iemobile|opera mini/i

      // 如果用户代理字符串包含上述任一特征，则认为是移动设备
      return mobileRegex.test(userAgent)
    },
    GetBaseShowFn () {
      this.showApplyPage = this.$store.state.applyShow

      this.showBase = false
    }
  }
}
</script>

<style lang="less">
* {
  margin: 0;
  padding: 0;
}
.myClassActive {
  // overflow: hidden;
  color: #5d4df6;
  background: linear-gradient(
    0deg,
    rgba(137, 247, 254, 0.6) 0%,
    rgba(102, 166, 255, 0.6) 100%
  );
  border-radius: 0.18rem;
  border: 0.02rem solid;
  border-image: linear-gradient(0deg, #4facfe, #00f2fe);
}
</style>
